module.exports = __webpack_public_path__ + "img/video-icon.2b1c8b5e.svg";